import axios from 'axios';
import toast from 'react-hot-toast';

// API utility functions
export const getApiBaseUrl = () => {
    return process.env.REACT_APP_BACKEND_URL || '';
};

export const getApiUrl = (endpoint) => {
    const baseUrl = getApiBaseUrl();
    return `${baseUrl}${endpoint}`;
};

// Global logout function
let logoutCallback = null;

export const setLogoutCallback = (callback) => {
    logoutCallback = callback;
};

// Axios response interceptor to handle 401 responses
axios.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.response?.status === 401) {
            // Clear local storage
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            
            // Remove authorization header
            delete axios.defaults.headers.common['Authorization'];
            
            // Show notification to user
            toast.error('Session expired. Please log in again.', {
                duration: 4000,
                position: 'top-right',
            });
            
            // Call logout callback if set
            if (logoutCallback) {
                logoutCallback();
            }
        }
        return Promise.reject(error);
    }
);

// Axios request interceptor to add auth token
axios.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
); 